// What the comparison page is showing, handed to the PDF and Excel exporters so the
// file prints what the person sees (Drew, 2026-10-05: "what they see, when they're
// on the comparison, is what they should print"). One flag decides it today:
//   cost_benefit_journey — the Cost Benefit card shows the per-strategy journey
//                          cards instead of the paired Year-1 / Year-N bars
// The "Pay the tax, or put it to work" doors (`alt_doors`) are never printed: the
// comparison_v3 page replaces them.
// With comparison_v3 on, the comparison page's Export PDF prints the v4 report
// (src/lib/comparisonReport.ts) instead; this view still drives the dashboard's
// Export and Excel.

export interface ExportView {
  /** Cost Benefit card draws the journey cards (flag `cost_benefit_journey`). */
  journey: boolean;
}

/** Nothing switched on: the page as it reads with the flag off. */
export const LEGACY_EXPORT_VIEW: ExportView = { journey: false };
